<script>
import Service from '@/services/movement-instruction';
import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';
import conf from '../../common/genericPanelConf';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

export default{
    props: ['item', 'record'],
    emits: ['updateVessel'],
    components: {Dialog, DataTable, Column, Button},
    data(){
        return {
            visible: false,
            selectedVessel: null,
            loading: false,
            filters: {
                imoNumber: null,
                name: null
            },
            data: [],
            winWidth: window.innerWidth,
            params: {
                start: 0,
                limit: 10
            },
            total: 0
        }
        
    },
    mounted(){
        this.configuration = conf.getConfiguration('Vessel');
        this.params.sort = JSON.stringify([{property: this.configuration.idColumn.charAt(0).toUpperCase() + this.configuration.idColumn.slice(1), direction: 'asc'}]);
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        }
    },
    methods: {
        show(){
            this.visible = true;
            this.loadData();
        },
        showWithName(name){
            this.visible = true;
            this.loadData();
        },
        loadData(){
            if(this.record.id){
                let searchParams = {
                    imoNumberFilter: this.filters.imoNumber,
                    vesselNameFilter: this.filters.name,
                    movInstrHeaderId: this.record.id,
                    start: this.params.start,
                    limit: this.params.limit
                };

                Service.getAcceptedVesselList(searchParams, response => {
                    if(response.success){
                        this.data = response.data;
                        this.total = response.totalCount

                        if(!this.total || this.total == 0){
                            this.$toast.add({detail: this.$t('VesselAcceptance.msg.noValidAcceptanceFound'), life:3000, severity:'warn'});
                        }
                    } else {
                        this.$toast.add({detail: response.message && response.message != '' ? this.$t(response.message) :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
            }
            else{
                this.$toast.add({detail: this.$t('VesselAcceptance.msg.movementInstructionNotCreted'), life:3000, severity:'warn'});
            }
        },
        onPage(event){
            this.params.start = event.first;
            this.loadData();
        },
        closeDialog(elem){
            this.$emit('updateVessel', elem);
            this.filters = {
                imoNumber: null,
                name: null
            };
            this.data = [];
            this.selectedVessel = null;
            this.visible= false;
        }
    }
  }
</script>


<template>
    <main>
        <Dialog :header="$t('vessel.search')" v-model:visible="visible" :modal="true">

            <div class="grid formgrid" >
              <div class="col-12 lg:col-3 m-4 field">
                <span class="p-float-label">
                  <InputText 
                    id="imoNumber" type="text" 
                    v-model="filters.imoNumber" 
                    :class="{'w-full': true}" />
                  <label for="imoNumber" >{{$t('vessel.imoNumber')}}</label>
                </span>
              </div>
              <div class="col-12 lg:col-3 m-4 field">
                <span class="p-float-label">
                  <InputText 
                    id="name" type="text" 
                    v-model="filters.name" 
                    :class="{'w-full': true}" />
                  <label for="name">{{$t('vessel.name')}}</label>
                </span>
              </div>
                <Button :label="$t('btn.search')" icon="pi pi-search" class="m-4 p-button-outlined" @click="loadData" />
            </div>

            <DataTable  style="height: 26vw" :loading="loading" :reorderableColumns="true"
                v-model:selection="selectedVessel" selectionMode="single" dataKey="id"
                :paginator="true" :rows="params.limit" @page="onPage($event)" :totalRecords="total"
                :value="data" :lazy="true" showGridlines stripedRows  ref="dt" :resizableColumns="true" columnResizeMode="expand" 
                >
                     <Column :exportable="false" style="min-width:8rem" :reorderableColumn="false">
                        <template #body="slotProps">
                            <Button icon="pi pi-plus" class="grid-action-btn p-button-rounded p-button-outlined" @click="closeDialog(slotProps.data)"/>
                        </template>
                    </Column>
                    <Column 
                    v-for="col of configuration.columns" :field="col.name" :header="$t(col.label)" :key="col.name" :dataType="col.type" 
                    style="width: 240px"
                    :sortable="true"
                    :ref="col.name" :showFilterMenu="col.type == 'date'" :showFilterOperator="false"
                    :hidden="col.gridHide">
                    <template #body="element">
                        <i class="pi" :class="{'true-icon pi-check-circle': element.data[col.name], 'false-icon pi-times-circle': !element.data[col.name]}" v-if="col.type=='boolean'"></i>
                        <span v-else-if="col.type=='date'">{{element.data[col.name] != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data[col.name])) : null}}</span>
                        <span v-else>
                            {{element.data[col.name]}}
                        </span>
                    </template>
                </Column>

                <template #empty>
                    {{$t('noRecordsFound')}}
                </template>
            </DataTable>
        </Dialog>
    </main>
</template>